module.exports = __webpack_public_path__ + "static/img/img-home_join.bd015964.png";